import React from 'react';
import { PatientInfoCardComponent } from '../../../../components/Cards';
import { usePatient } from '../../../../contexts/patient';

const capitalize = (s: string | undefined) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const PatientInfoCard = () => {
  const patient = usePatient();
  return (
    <PatientInfoCardComponent
      displayName={patient.getDisplayName()}
      birthDate={patient.getDateOfBirth()}
      familyName={patient.getLastName()}
      firstName={patient.getFirstName()}
      gender={capitalize(patient.getGender())}
      active={patient.isActive()}
      mrn={patient.getMrn()}
      loading={patient.loading}
      status="On-going"
    />
  );
};

export default PatientInfoCard;
